import React from 'react';

export default class Toast extends React.Component{

    getClassName(){
        let {show, success} = this.props;

        let className = "";

        if(!success){
            className = className.concat("error-msg")
        }else{
            className = className.concat("success-msg");
        }

        return (show) ? className.concat(" active") : className.replace("active", "");
    }

    render(){
        return(
            <div className={this.getClassName()}>{this.props.message}</div>
        )
    }
}